import {AssertUtils,CookieUtils} from 'xmgoing-utils'
import {dbUtils} from 'xmgoing-utils';
import {QueryCommand} from "xmgoing-server";
import {StorageUtils} from 'xmgoing-utils';
import SysConfigUtils from '@/utils/sysConfigUtils';
import {clearAccountInfoCache} from '@/components/Application/hooks/useAccountInfo';

let PlatformPrefix = SysConfigUtils.go_eplat_adress;

export const useSwitchTenant = () => {
  const _loginSuccess = (backData) => {
    clearCache();
    backData.loginUserType = backData.account;
    // 返回的数据
    const backDs = backData;

    // 登陆成功的操作
    const sessionId = backDs.access_token;

    StorageUtils.addItem('access_token', sessionId);
    StorageUtils.addItem('curPageId', backData.user_id);

    // 缓存token
    CookieUtils.setCookie('admin-access-token', sessionId, 30);
    // 清空验证码
    CookieUtils.setCookie('vCodeValidate', '', -1);
    // 获取登陆用户的类型
    const loginUserType = backDs.position;
    changeToJavaFieldName(backData);
    // 用户类型
    StorageUtils.addSessionItem('loginUserType', loginUserType);
    if (sessionId != null && sessionId.length > 0) {
      StorageUtils.addSessionItem('userId', backData.user_id);
      StorageUtils.addSessionItem('loginPortal', backData.loginUserType);
      StorageUtils.addSessionItem('sessionId', sessionId);

      // CurrentUtils._loadUser(false, backData);

      const queryCommand = new QueryCommand({
        url: PlatformPrefix + `/api/pe-portal/users/getUserInfo`,
        method: 'GET',
        showTip: false,
      });
      //执行查询操作
      let successFun = (userJson: any) => {
        console.log(userJson);
        dbUtils.saveCachUser(userJson, userJson.id);
      };
      queryCommand.executeQuery({ successFun });

      jumpPageByPosition(loginUserType, sessionId, backData.user_id);
    }
  };

  return {
    _loginSuccess,
  };
};

const clearCache = () => {
  // 清空系统缓存
  StorageUtils.removeSessionItem('system_total_configs');

  // 清空二级菜单
  StorageUtils.removeSessionItem('loginUserType');
  StorageUtils.removeSessionItem('userId');
  StorageUtils.removeItem('loginPortal');
  StorageUtils.removeItem('curHref');
  StorageUtils.removeItem('curMenuId');
  StorageUtils.removeSessionItem('curMenuId');
  StorageUtils.removeSessionItem('curMenuEntryId');
  clearAccountInfoCache();
};

function changeToJavaFieldName(backData: any) {
  Object.keys(backData).forEach((propName) => {
    if (propName.indexOf('_') > 0) {
      const newProp = propName.split('_')[0] + firstToUpper2(propName.split('_')[1]);
      backData[newProp] = backData[propName];
    }
    backData['id'] = backData['userId'];
  });
}

function firstToUpper2(str: any) {
  return str.replace(/\b(\w)(\w*)/g, function ($0: any, $1: any, $2: any) {
    return $1.toUpperCase() + $2.toLowerCase();
  });
}

export function jumpPageByPosition(loginUserType, sessionId, userId) {
  clearAccountInfoCache();
  function parseBoolean(str) {
    if (!AssertUtils.isNotEmpty(str)) {
      return false;
    }
    if (str === 'true' || str === true || str === 1 || str === '1') {
      return true;
    }
    return false;
  }

  let url = window.location.href;

  url = url.split('login')[0];
  const loginPortal = SysConfigUtils.loginPortal;
  if (loginUserType === 'sceneAdmin') {
    // 打开大屏幕
    window.location.href =
      SysConfigUtils.bigScreenUrl +
      `?url=${url}&loginUserType=${loginUserType}&userId=${userId}&loginPortal=${loginPortal}&sessionId=` +
      sessionId;
    return;
  }
  let customerPortalFlag = false; // 自定义首页
  let groupGatewayCode = '';
  let unitGatewayCode = '';
  let customerPortalUrl = '';
  if (window.systemTotalParams) {
    // 是否自定义了首页
    customerPortalFlag = parseBoolean(window.systemTotalParams.customerPortalFlag);
    if (customerPortalFlag) {
      customerPortalUrl = window.systemTotalParams.customerPortalUrl;
    } else {
      customerPortalUrl = '';
    }
  }
  const projectI18n = StorageUtils.getItem('projectI18n') || 'zh-CN';


  const Url = new URL('', location.origin);
  const searchParams = Url.searchParams;
  searchParams.append('loginUserType', loginUserType);
  searchParams.append('userId', userId);
  searchParams.append('loginPortal', loginPortal);
  searchParams.append('sessionId', sessionId);
  searchParams.append('projectI18n', projectI18n);
  searchParams.append('customerPortalUrl', customerPortalUrl);
  searchParams.append('_t', Date.now().toString());

  const toUrl = Url.toString()

  window.location.href = toUrl;
  // // 刷新页面
  // window.location.reload();
}
